import { Divider, InnerContentItem, Text } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

export function NameSummaryField({
  field,
}: {
  field: components["schemas"]["NameCheckField"];
}) {
  const { t } = useTranslation();

  const getNameTypeText = (type: string) => {
    switch (type) {
      case "PRIMARY":
        return t("Primary name");
      case "ALIAS":
        return t("Alias");
      case "MAIDEN":
        return t("Maiden name");
      case "FORMER":
        return t("Previous name");
      default:
        return "-";
    }
  };

  return (
    <>
      <InnerContentItem
        label={t("Legal first name")}
        testID="name-summary-first-name"
      >
        {field.value[0]?.first_name || "-"}
      </InnerContentItem>

      <InnerContentItem
        label={`${t("Middle name")} (${t("if applicable")})`}
        testID="name-summary-middle-name"
      >
        {field.value[0]?.middle_name || "-"}
      </InnerContentItem>

      <InnerContentItem
        label={t("Legal last name")}
        testID="name-summary-last-name"
      >
        {field.value[0]?.last_name || "-"}
      </InnerContentItem>

      {field.value.slice(1).map((name, index) => (
        <Fragment key={index}>
          <Divider marginHorizontal="space-4" />

          <InnerContentItem>
            <Text
              style="summary/section-title"
              color="text-weak"
              testID={`name-summary-previous-name-${index + 1}`}
            >
              {t("Previous name")} {index + 1}
            </Text>
          </InnerContentItem>

          <InnerContentItem
            label={t("Name type")}
            testID={`name-summary-name-type-${index + 1}`}
          >
            {getNameTypeText(name.type)}
          </InnerContentItem>

          {["FORMER", "ALIAS"].find((t) => t === name.type) && (
            <InnerContentItem
              label={t("Alias")}
              testID={`name-summary-previous-alias-${index + 1}`}
            >
              {name.first_name || "-"}
            </InnerContentItem>
          )}

          {["FORMER", "MAIDEN"].find((t) => t === name.type) && (
            <InnerContentItem
              label={t("Legal last name")}
              testID={`name-summary-previous-last-name-${index + 1}`}
            >
              {name.last_name || "-"}
            </InnerContentItem>
          )}
        </Fragment>
      ))}
    </>
  );
}
